import React, { useEffect } from "react";
import Header from "./sections/Header";
import Hero from "./sections/Hero";
import About from "./sections/About"
import Skills from "./sections/Skills";
import Projects from "./sections/Projects";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";
import { Analytics } from '@vercel/analytics/react';
import { trackPageView } from './utils/analytics';

function App() {
  useEffect(() => {
    const handleLocationChange = () => trackPageView(window.location.href);

    handleLocationChange();
    window.addEventListener("hashchange", handleLocationChange);

    return () => window.removeEventListener("hashchange", handleLocationChange);
  }, []);

  return (
    // <ReactLenis root>
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Contact />
      </main>
      <Footer />
      <Analytics />
    </>
    // </ReactLenis>
  );
}

export default App;
